"use strict";
if(!customElements.get('sticky-cart')) {
  class StickyCart extends HTMLElement {
    constructor() {
      super();
      var _this = this,
        secId = this.dataset.section,
        vr = this.querySelector('#sticky-variants');
  
      window.addEventListener("scroll",function(){
         var y = window.scrollY,
            btn = document.querySelector('.product-form__submit'),
            cartBtn = '300',
            mbQury = window.matchMedia('(max-width: 767px)');
          if(btn) {
            cartBtn = btn.offsetTop + 200;
            if(mbQury.matches === true) cartBtn = btn.offsetTop + window.innerHeight;
          }
          if(y > cartBtn){
           _this.classList.add('active');
          } else {
            _this.classList.remove('active');
          }
      });
      if(vr){
        vr.addEventListener('change', function(e){
            var opt = this.selectedOptions[0],
              vrcontainer = document.getElementById(`variant-selects-${secId}`).querySelectorAll('select, fieldset');
            vrcontainer.forEach((field, index) => {
              if(field.tagName === 'SELECT'){
                field.querySelectorAll("option").forEach((option) => {
                  if(option.value === opt.dataset[`option${index + 1}`]){
                    option.selected = true;
                  }
                });
              } else if(field.tagName === 'FIELDSET'){
                field.querySelectorAll("input").forEach((input) => {
                  input.removeAttribute("checked");
                  if(input.value === opt.dataset[`option${index + 1}`]){
                    input.click();
                  }
                });
              }
            });
        });
      }
  
      this.querySelectorAll('.linkQty').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
  
      const syncQty = document.querySelectorAll(".linkInput");
      syncQty.forEach((input) => {
          input.addEventListener("change", function(){
            const value = this.value;
            syncQty.forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.value = value;
              }
            });
          });
      });
    }
    onButtonClick(e){
      e.preventDefault();
      const qtyinput = document.querySelector('.mianQty'),
        previousValue = qtyinput.value;
      e.target.name === 'plus' ? qtyinput.stepUp() : qtyinput.stepDown();
      if(previousValue !== qtyinput.value) qtyinput.dispatchEvent(new Event("change"));
    }
  }
  customElements.define("sticky-cart", StickyCart);
}
if(!customElements.get('back-in-stock')){
  class BackInStock extends HTMLElement {
    constructor() {
      super();
      this.bisCookie = 'backinstock'+this.dataset.id;
      this.form = this.querySelector('form');
      this.variant = this.querySelector('.bisVariant');
  
      this.form.addEventListener("submit", this.BackinStockSubmit.bind(this));
  
      window.addEventListener('DOMContentLoaded',function(){
        const error = window.location.href.indexOf('form_type=contact') > -1;
        if(window.location.href.indexOf('contact_posted=true') > -1 || error){
            if(getCookie('contatForm') == 'backinstockform'){
                var bismodal = new tingle.modal({
                      cssClass: ['bismodal'],
                      onClose: function(){
                          setCookie('contatForm','',1);
                      }
                });
                bismodal.setContent(document.getElementById('backStockSuccess'));
                bismodal.open();
                
            }
        }
      });
    }
    BackinStockSubmit(event){
        event.preventDefault();
        var vrId = this.querySelector('.bisVariant').dataset.id,
          cvr = vrId;
        if(getCookie(this.bisCookie) != null){
            cvr = getCookie(this.bisCookie)+'_'+vrId;
        }
        setCookie(this.bisCookie,cvr,1);
        setCookie('contatForm','backinstockform',1);
    }
    checkBackinstock(vr){
      this.variant.value = vr.title;
      this.variant.setAttribute('data-id', vr.id);
      var formMsg = this.querySelector('.bisMsg');
      if(vr.available){
        this.classList.add('hide');
      } else {
        this.classList.remove('hide');
         if(getCookie(this.bisCookie) != null){
           this.form.classList.remove('hide');
           formMsg.classList.add('hide');
           var str = String(getCookie(this.bisCookie)).split("_");
           for(var i=0; i<str.length; i++){
             if(str[i] == vr.id){
               this.form.classList.add('hide');
               formMsg.classList.remove('hide');
             }
           }
         }
      }
     }
  }
  customElements.define("back-in-stock", BackInStock);
}

var tearmFields = document.querySelectorAll('.tearmCheck'),
  dyButs = document.querySelectorAll('.shopify-payment-button__button');

if(tearmFields.length){
  setTimeout(function(){
    dyButs.forEach((btn) => { btn.disabled = true; });
  },300);
  
  tearmFields.forEach((tearm) => {
    tearm.onchange = function(){
      var dyBut = this.closest('.product-form__buttons').querySelector('.shopify-payment-button__button');
      dyBut.disabled = !this.checked;
    };
  });
  
}

/* TD: product video — autoplay gedempt in loop, geluid-aan knop, lichte bron per scherm (SD 480p ≤767px / HD 720p, nooit 1080p) — v2 2026-09-22 */
(function(){
  var SD_MAX = 767;
  var wantSD = window.innerWidth <= SD_MAX || !!(navigator.connection && navigator.connection.saveData);

  function tdPickUrl(sources){
    var sd = null, hd = null, fhd = null;
    (sources || []).forEach(function(s){
      if(!s || s.format !== 'mp4' || !s.url) return;
      var h = s.height || 0;
      if(h <= 480){ if(!sd || h > (sd.height||0)) sd = s; }
      else if(h <= 720){ if(!hd || h > (hd.height||0)) hd = s; }
      else { if(!fhd || h < (fhd.height||0)) fhd = s; }
    });
    var pick = wantSD ? (sd || hd || fhd) : (hd || fhd || sd);
    return pick ? pick.url : null;
  }

  function tdLoadSources(){
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if(!m) return Promise.resolve({});
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, 2500) : null;
    return fetch('/products/' + m[1] + '.js', ctrl ? { signal: ctrl.signal } : undefined)
      .then(function(r){ return r.ok ? r.json() : {}; })
      .then(function(d){
        var map = {};
        ((d && d.media) || []).forEach(function(md){
          if(md && md.media_type === 'video' && md.sources){
            var url = tdPickUrl(md.sources);
            if(url) map[String(md.id)] = url;
          }
        });
        return map;
      })
      .catch(function(){ return {}; })
      .then(function(map){ if(timer) clearTimeout(timer); return map; });
  }

  function tdApplySrc(v, map){
    if(v.dataset.tdSrc) return;
    var slide = v.closest('.videoSlide');
    var id = slide ? slide.getAttribute('data-media-id') : null;
    var url = id && map ? map[String(id)] : null;
    if(url){
      var wasPlaying = !v.paused;
      v.removeAttribute('src');
      v.src = url;
      v.dataset.tdSrc = wantSD ? 'sd' : 'hd';
      if(wasPlaying){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }
    } else {
      v.dataset.tdSrc = 'default';
    }
    v.setAttribute('autoplay','');
    v.preload = 'auto';
  }

  function tdPlay(v){
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  }

  function tdInitProductVideos(){
    var videos = document.querySelectorAll('.product-image__slider .videoSlide video');
    if(!videos.length) return;
    if(!document.getElementById('td-video-css')){
      var css = document.createElement('style');
      css.id = 'td-video-css';
      css.textContent = '.videoSlide{position:relative}.td-unmute{position:absolute;top:12px;right:12px;z-index:5;border:0;border-radius:999px;padding:8px 14px;font:600 13px/1 inherit;color:#fff;background:rgba(0,0,0,.6);cursor:pointer;display:inline-flex;align-items:center;gap:6px}.td-unmute:hover{background:rgba(0,0,0,.8)}';
      document.head.appendChild(css);
    }
    var ready = tdLoadSources().then(function(map){
      videos.forEach(function(v){ tdApplySrc(v, map); });
    });
    videos.forEach(function(v){
      v.muted = true;
      v.loop = true;
      v.setAttribute('muted','');
      v.setAttribute('playsinline','');
      v.setAttribute('webkit-playsinline','');
      var slide = v.closest('.videoSlide');
      if(slide && !slide.querySelector('.td-unmute')){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'td-unmute';
        b.setAttribute('aria-label','Geluid aanzetten');
        b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05A4.5 4.5 0 0016.5 12z"/></svg><span>Geluid aan</span>';
        b.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          v.muted = false; v.volume = 1;
          tdPlay(v);
          b.remove();
        });
        v.addEventListener('volumechange', function(){ if(!v.muted && b.parentNode) b.remove(); });
        slide.appendChild(b);
      }
    });
    if(!('IntersectionObserver' in window)){
      ready.then(function(){ videos.forEach(tdPlay); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if(en.isIntersecting && en.intersectionRatio >= 0.6){
          ready.then(function(){ tdPlay(v); });
        } else if(!v.paused){
          v.pause();
        }
      });
    }, { threshold: [0, 0.6] });
    videos.forEach(function(v){ io.observe(v); });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', tdInitProductVideos, { once: true });
  } else {
    tdInitProductVideos();
  }
})();
